import { Owner } from "./Owner.model";
import { Company } from "./Company.model";
import { Approver } from "./Approver.model";
import { ApprovalType } from "../shared/enums/ApprovalType";

export class Refund {
    _id: string;
    hashTrackId: string;
    title: string;
    value: number;
    number: number;
    consultant: any;
    status: any;
    status_updated: any = [];
    statusFinancial: number = 1;
    expenses: any = [];
    paidCustomer: boolean = false;
    associatedBillingLetter: boolean = false;
    billingLetterId: String = '';
    valuePaidCustomer: number = 0;
    coted: boolean = false;
    dateApproved: Date;
    approver: Approver;
    approvers: any = [];
    created: Date;
    sapIntegrated: Boolean;
    sapDocEntry: String;
    refundCanceled: Boolean;
    attachment: String;
    excellenceCenter?: any

    loadFromServer(r: any) {

        if (r._id)
            this._id = r._id;

        if (r.hashTrackId !== undefined)
            this.hashTrackId = r.hashTrackId;

        if (r.title)
            this.title = r.title;

        if (r.value)
            this.value = r.value;

        if (r.number)
            this.number = r.number;

        if(r.consultant)
            this.consultant = r.consultant;

        if(r.status)
            this.status = r.status;

        if(r.status_updated)
            this.status_updated = r.status_updated;

        if(r.statusFinancial)
            this.statusFinancial = r.statusFinancial;

        if(r.paidCustomer)
            this.paidCustomer = r.paidCustomer;

        if(r.valuePaidCustomer)
            this.valuePaidCustomer = r.valuePaidCustomer;

        if(r.associatedBillingLetter)
            this.associatedBillingLetter = r.associatedBillingLetter;

        if(r.billingLetterId)
            this.billingLetterId = r.billingLetterId;

        if(r.coted)
            this.coted = r.coted;

        if (r.dateApproved !== undefined)
            this.dateApproved = r.dateApproved;

        if(r.approver)
            this.approver.loadFromServer(r.approver);

        if(r.approvers)
            this.approvers = r.approvers;

        if(r.sapIntegrated)
            this.sapIntegrated = r.sapIntegrated;

        if(r.sapDocEntry)
            this.sapDocEntry = r.sapDocEntry;

        if(r.refundCanceled)
            this.refundCanceled = r.refundCanceled

        if(r.attachment)
            this.attachment = r.attachment;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Refund.model.ts